import { AnnouncementsFilterItem } from "../../../types/api/announcements";
import { AdsListStatus } from "../../../types/api/ads";
import { BriefcaseIcon, PlayIcon, ArchiveIcon } from "@primer/octicons-react";

export const filterItems: AnnouncementsFilterItem[] = [
    {
        label: 'Все объявления',
        icon: <BriefcaseIcon />,
        filter: undefined,
        isBlocked: undefined
    },
    {
        label: 'Активные',
        icon: <PlayIcon />,
        filter: AdsListStatus.ACTIVE,
        isBlocked: false
    },
    {
        label: 'В архиве',
        icon: <ArchiveIcon />,
        filter: AdsListStatus.ARCHIVED,
        isBlocked: true
    }
];

export const emptyListDescription = `По вашему запросу не найдено
подходящих объявлений`;